<mat-icon
  class="copy-button"
  [matTooltip]="tooltip() ?? ''"
  (click)="copy()"
>
  {{ isUrl() ? "link" : "content_copy" }}
</mat-icon>
